import { render, staticRenderFns } from "./TaxonAutocomplete.vue?vue&type=template&id=6f1f3fa7"
import script from "./TaxonAutocomplete.vue?vue&type=script&lang=js"
export * from "./TaxonAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports